/**
 * This module was automatically generated by `ts-interface-builder`
 */
import * as t from "ts-interface-checker";
// tslint:disable:object-literal-key-quotes

export const PatientSchedulerCreateFields = t.iface([], {
  "schedule_request_id": t.opt("string"),
  "schedule_request_patient_mrn": t.opt("string"),
  "schedule_request_provider_npi": t.opt("string"),
  "schedule_request_appointment_type": t.opt("string"),
  "schedule_request_visit_duration": t.opt("number"),
  "schedule_request_source": t.opt("string"),
  "schedule_request_created_successfully": t.opt("boolean"),
  "ecw_appointment_number": t.opt("number"),
  "schedule_request_generated_url": t.opt("string"),
  "created_by_user_email": t.opt("string"),
});

export const PatientSchedulerOpenFields = t.iface([], {
  "schedule_request_id": t.opt("string"),
  "schedule_request_patient_mrn": t.opt("string"),
  "schedule_request_provider_npi": t.opt("string"),
  "schedule_request_appointment_type": t.opt("string"),
  "schedule_request_visit_duration": t.opt("number"),
  "schedule_request_source": t.opt("string"),
  "schedule_request_opened_successfully": t.opt("boolean"),
  "ecw_appointment_number": t.opt("number"),
  "schedule_request_generated_url": t.opt("string"),
  "opened_at_utc": t.opt("number"),
});

export const PatientSchedulerRequestFields = t.iface([], {
  "schedule_request_id": t.opt("string"),
  "schedule_request_patient_mrn": t.opt("string"),
  "schedule_request_provider_npi": t.opt("string"),
  "schedule_request_appointment_type": t.opt("string"),
  "schedule_request_visit_duration": t.opt("number"),
  "schedule_request_source": t.opt("string"),
  "schedule_request_requested_successfully": t.opt("boolean"),
  "ecw_appointment_number": t.opt("number"),
  "schedule_request_generated_url": t.opt("string"),
  "request_sent_at_utc": t.opt("number"),
  "appointment_start_time": t.opt("number"),
  "appointment_end_time": t.opt("number"),
  "is_schedule_request_expired": t.opt("boolean"),
});

export const CSDisclaimerTest = t.iface([], {
  "should_show_controlled_substance_disclaimer": "boolean",
  "rv_main_reason": t.array("string"),
  "rv_secondary_reason": t.array("string"),
  "rv_specialty_care": t.array("string"),
  "number_of_matches": "number",
  "number_of_matches_with_cs_license": "number",
  "chose_no_match": "boolean",
  "chose_cs_provider": "boolean",
});

export const ClientRejectMatches = t.name("CSDisclaimerTest");

export const ClientBookAppointment = t.intersection(t.iface([], {
  "provider_id": "string",
  "timeslot": t.iface([], {
    "startTime": "number",
    "endTime": "number",
    "timezone": "string",
  }),
  "was_provider_additional_match": t.opt("boolean"),
}), "CSDisclaimerTest");

export const SoharVerificationFields = t.iface([], {
  "patient_already_in_sohar": "boolean",
  "patient_request_data": t.opt(t.iface([], {
    "request_sent_timestamp": "number",
    "date_of_birth": "string",
    "state": "string",
  })),
  "session_patient_id": "string",
  "patient_created_response": t.opt(t.iface([], {
    "timestamp": "number",
    "success": "boolean",
    "sohar_patient_id": "string",
  })),
  "payer_found": "boolean",
  "missing_payer_name": t.opt("string"),
  "verification_request_data": t.iface([], {
    "request_sent_timestamp": "number",
    "member_id": "string",
    "patient_id": "string",
    "payer_id": "string",
  }),
  "verification_response": t.iface([], {
    "timestamp": "number",
    "success": "boolean",
    "verification_id": t.opt("string"),
    "patient_id": t.opt("string"),
  }),
  "verification_data_inserted": t.iface([], {
    "sohar_patient_id": "string",
    "session_patient_id": "string",
    "payer_id": "string",
    "payer_name": "string",
    "insurance_carrier_id": t.opt("number"),
    "member_id": "string",
    "verification_status": "string",
    "verification_id": "string",
  }),
  "is_retry": "boolean",
  "is_completely_sohar_verified": t.opt("boolean"),
});

export const SoharVerificationIntakeFields = t.iface([], {
  "sohar_verification_intake_fields": t.intersection(t.iface([], {
    "has_medical_info": "boolean",
    "patient_data_unsent": t.iface([], {
      "mrn": t.opt("string"),
      "intake_started_at": "number",
      "session_patient_id": "string",
      "medical_info": t.iface([], {
        "insurance_member_id": "string",
        "insurance_payer_name": "string",
      }),
    }),
    "sohar_api_call_reason": t.opt(t.union(t.lit('new'), t.lit('established'))),
  }), "SoharVerificationFields"),
});

export const SoharVerificationZocDocFields = t.iface([], {
  "sohar_verification_zocdoc_fields": t.intersection(t.iface([], {
    "zd_insurance_data": t.iface([], {
      "mrn": t.opt("string"),
      "insurance_carrier": t.opt("string"),
      "insurance_plan": t.opt("string"),
      "insurance_member_id": t.opt("string"),
    }),
    "sohar_api_call_reason": t.opt(t.union(t.lit('new'), t.lit('established'))),
  }), "SoharVerificationFields"),
});

export const SoharVerificationZocDocRecheckFields = t.iface([], {
  "sohar_verification_zocdoc_recheck_fields": t.iface([], {
    "appointment_id": t.opt("string"),
    "session_patient_id": t.opt("string"),
    "rechecking": t.opt("boolean"),
    "current_timestamp_utc": t.opt("number"),
    "sohar_api_call_reason": t.opt(t.union(t.lit('new'), t.lit('established'))),
  }),
});

export const SoharApiResponseWebhookFields = t.iface([], {
  "sohar_api_response_webhook_fields": t.iface([], {
    "sohar_verification_id": "string",
    "sohar_verification_status": "string",
    "session_patient_id": "string",
    "received_at": "number",
  }),
});

export const SoharVerificationAppointmentRecheckFields = t.iface([], {
  "sohar_verification_appointment_recheck_fields": t.intersection(t.iface([], {
    "ehr_appointment_id": "string",
    "sohar_api_call_reason": t.union(t.lit('new'), t.lit('established')),
  }), "SoharVerificationFields"),
});

export const EventType = t.union(t.lit('client'), t.lit('command'), t.lit('query'), t.lit('scripts'), t.lit('MQ'), t.lit('message_handler'), t.lit('track'), t.lit('api_call'), t.lit('healow'), t.lit('nirvana'), t.lit('db'));

export const EventFlow = t.union(t.lit('get_me_infinity'), t.lit('meta_present_screen_error'), t.lit('no_answer_medical_info'), t.lit('patient_provider_match_error'), t.lit('book_appointment'), t.lit('fetch_schedule_id'), t.lit('fetch_timeslots_for_schedule_id'), t.lit('get_provider_matches'), t.lit('get_active_patient'), t.lit('get_active_patients'), t.lit('get_active_patients_by_mrns'), t.lit('get_provider_timeslots'), t.lit('estimate_coverage'), t.lit('document_upload'), t.lit('update_document'), t.lit('update_file_url'), t.lit('upload_file'), t.lit('clear_assessment_response'), t.lit('intake__questions__answer_question'), t.lit('intake_submit'), t.lit('reject_matches'), t.lit('undo_insurance_response'), t.lit('intake__patient_auth__authenticate_from_email_link'), t.lit('intake__patient_auth__submit_email'), t.lit('patient_scheduler__create_schedule_request'), t.lit('patient_scheduler__open_schedule_request'), t.lit('patient_scheduler__request_appointment'), t.lit('portal__convert_user'), t.lit('portal__create_user'), t.lit('portal__update_user'), t.lit('admin__new_provider_itx_pending_matches__email'), t.lit('admin__new_provider_itx_request__accept'), t.lit('admin__new_provider_itx_schedule_request__expired'), t.lit('admin__originating_provider_itx_request__accept'), t.lit('admin__originating_provider_itx_request__create'), t.lit('admin__originating_provider_itx_request__expired'), t.lit('admin__originating_provider_itx_request__no_matches'), t.lit('admin__originating_provider_itx_schedule_request__expired'), t.lit('admin__patient_itx_request__accept'), t.lit('admin__patient_itx_request__create'), t.lit('admin__patient_itx_request__expired'), t.lit('admin__patient_itx_request__no_matches'), t.lit('admin__patient_itx_schedule_request__nudge'), t.lit('referrals__generate_link'), t.lit('referrals__specify_consent_for_sharing'), t.lit('ecw_snowflake_file_sync'), t.lit('ecw_snowflake_patient_email_sync'), t.lit('ecw_snowflake_provider_facilities_sync'), t.lit('ecw_snowflake_patient_insurance'), t.lit('get_all_provider_schedules'), t.lit('itx_generate_provider_matches'), t.lit('itx_is_match'), t.lit('populate_televisit_links'), t.lit('portal__cognito_barnard_user_conversion'), t.lit('portal__cognito_user_sync'), t.lit('process_failed_bookings'), t.lit('refresh_s3_links'), t.lit('remove_anonymous_files'), t.lit('send_files_to_service'), t.lit('send_sohar_cannot_verify_insurance_email'), t.lit('send_sohar_cannot_verify_insurance_sms'), t.lit('send_sohar_insurance_not_accepted_email'), t.lit('send_sohar_insurance_not_accepted_sms'), t.lit('send_sohar_schedule_appointment_email'), t.lit('send_sohar_schedule_appointment_sms'), t.lit('send_sohar_benefits_changed_email'), t.lit('send_sohar_benefits_changed_sms'), t.lit('send_sohar_verification_established_patient_request_appointment_recheck'), t.lit('send_sohar_verification_established_patient_recheck_zocdoc'), t.lit('send_sohar_verification_request_intakes'), t.lit('send_sohar_verification_request_zocdoc'), t.lit('sync_insurances_medallion'), t.lit('sync_ehr_patient_from_snowflake'), t.lit('sync_ehr_patient_from_snowflake_batch'), t.lit('sync_licenses_medallion'), t.lit('sync_patient_medications_from_snowflake'), t.lit('sync_ecw_patient_pharmacy_from_snowflake'), t.lit('sync_practices_medallion'), t.lit('sync_primary_practice_medallion'), t.lit('sync_provider_email_from_snowflake'), t.lit('sync_providers_medallion'), t.lit('transfer_unassigned_patients'), t.lit('update_insurance_table'), t.lit('update_ehr_patient_malformed_phone'), t.lit('verify_S3_files'), t.lit('send_first_completed_appointment_to_google_conversions_via_freshpaint'), t.lit('send_second_completed_appointment_to_google_conversions_via_freshpaint'), t.lit('consume_message'), t.lit('publish'), t.lit('subscribe'), t.lit('create'), t.lit('delete'), t.lit('read'), t.lit('update'), t.lit('receive_sohar_api_response_webhook'));

export const UnsetEventSpecification = t.iface([], {
});

export const DataPointType = t.iface([], {
  "layer": "EventType",
  "flow": "EventFlow",
  "start_time": "number",
  "timezone": "string",
  "correlation_id": "string",
  "action": t.opt("string"),
  "duration": t.opt("number"),
  "error": t.opt("any"),
  "success": t.opt("boolean"),
});

export const BaseEvent = t.iface([], {
  "version_event_source": "string",
  "version_event_schema": "string",
  "time_stamp": "number",
  "timezone": "string",
  "event": "EventFlow",
  "event_type": "EventType",
  "source": "string",
  "trigger_id_field": "string",
  "event_detail": t.iface([], {
    [t.indexKey]: "any",
  }),
  "correlation_id": "string",
  "is_success": "boolean",
});

const exportedTypeSuite: t.ITypeSuite = {
  PatientSchedulerCreateFields,
  PatientSchedulerOpenFields,
  PatientSchedulerRequestFields,
  CSDisclaimerTest,
  ClientRejectMatches,
  ClientBookAppointment,
  SoharVerificationFields,
  SoharVerificationIntakeFields,
  SoharVerificationZocDocFields,
  SoharVerificationZocDocRecheckFields,
  SoharApiResponseWebhookFields,
  SoharVerificationAppointmentRecheckFields,
  EventType,
  EventFlow,
  UnsetEventSpecification,
  DataPointType,
  BaseEvent,
};
export default exportedTypeSuite;
